import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const HIDE_PREFIXES = ["/subscribe", "/quiz", "/login", "/register", "/survey", "/admin"];
const SEEN_KEY = "aip_paywall_notice_seen";

export function PaywallNotice() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const hidden = HIDE_PREFIXES.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    if (!user || user.is_subscribed || hidden) return;
    if (sessionStorage.getItem(SEEN_KEY) === "1") return;
    setOpen(true);
  }, [user, hidden]);

  const dismiss = () => {
    sessionStorage.setItem(SEEN_KEY, "1");
    setOpen(false);
  };

  const goPro = () => {
    sessionStorage.setItem(SEEN_KEY, "1");
    setOpen(false);
    navigate("/subscribe");
  };

  if (!user || user.is_subscribed || hidden) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <DialogContent className="max-w-md rounded-3xl" data-testid="paywall-notice">
        <DialogHeader>
          <span className="mx-auto grid place-items-center h-14 w-14 rounded-2xl bg-primary/10 text-primary">
            <Crown className="h-7 w-7" />
          </span>
          <DialogTitle className="text-center font-heading font-extrabold text-2xl tracking-tight pt-2">
            AI Pathshaalaa is now Pro
          </DialogTitle>
          <DialogDescription className="text-center text-sm leading-relaxed pt-1">
            Our free period has ended. To continue enjoying your personalized path, curated lessons and all
            Pro features, you'll need a Pro subscription — <b>₹555/month</b> or <b>₹3,333/year</b> (just ₹278/mo).
          </DialogDescription>
        </DialogHeader>
        <p className="text-center text-xs text-muted-foreground -mt-1">
          Don't worry — your path, progress and streak are saved and waiting for you.
        </p>
        <div className="mt-2 flex flex-col gap-2">
          <Button data-testid="paywall-notice-cta" onClick={goPro} className="w-full rounded-full">
            See plans &amp; continue <ArrowRight className="h-4 w-4" />
          </Button>
          <Button data-testid="paywall-notice-later" variant="ghost" onClick={dismiss} className="w-full rounded-full text-muted-foreground">
            Maybe later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
